const SCOPE_KEYS = ["offices", "departments", "designations", "employeeTypes"];

export const toMultiSelectArray = (value) => {
	if (value == null || value === "") return [];
	return Array.isArray(value) ? value : [value];
};

/** Align stored ids with option value types so Ant Design multiple select works reliably */
export const alignMultiSelectValues = (selected, options = []) => {
	const values = toMultiSelectArray(selected);
	if (!options.length) return values;

	const sample = options[0]?.value;
	if (sample == null) return values;

	if (typeof sample === "number") {
		return values.map((v) => Number(v)).filter((v) => !Number.isNaN(v));
	}
	return values.map((v) => String(v));
};

export const normalizeGeneralScopeFields = (general = {}) => {
	const next = { ...general };
	SCOPE_KEYS.forEach((key) => {
		next[key] = toMultiSelectArray(general[key]);
	});
	return next;
};
